module.exports = __webpack_public_path__ + "img/openright.4eaf1f7e.png";